import React from 'react';
import Button from '@mui/material/Button';
import { Grid } from '@mui/material';
import { getJWT } from '../../utils/jwtMethods';
import { API_BASE_URL } from '../../utils/utils';

interface FileDownloadProp {
  width?: string;
  url: string;
  displayedText?: string;
  fileAvailable?: boolean;
  centered?: boolean;
}

const FileDownload: React.FC<FileDownloadProp> = ({
  width = '45%',
  url,
  displayedText = 'Download Resume',
  fileAvailable = true,
  centered = false,
}) => {
  const handleDownload = () => {
    fetch(`${API_BASE_URL}${url}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getJWT()}`,
      },
    })
      .then(async response => {
        if (!response.ok) throw new Error('Network response was not ok.');

        const blob = await response.blob();
        const cd = response.headers.get('Content-Disposition');
        const filename =
          parseFilenameFromDisposition(cd) ||
          filenameFromUrl(url) ||
          (blob.type === 'application/pdf' ? 'download.pdf' : 'download.bin');


        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch(error => {
        console.error(
          'There has been a problem with your fetch operation:',
          error,
        );
      });
  };

  return (
    <Grid item container flexDirection="row" justifyItems="flex-start">
      <Grid item xs={8} md={8} sx={{ textAlign: centered ? 'center' : 'left' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleDownload}
          sx={{ 
            bgcolor: 'var(--ttg-black)', 
            width: width,
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
          disabled={!fileAvailable}
        >
          {displayedText}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FileDownload;
function parseFilenameFromDisposition(cd: string | null): string | null {
  if (!cd) return null;
  // RFC 5987: filename*=UTF-8''<urlencoded>
  let m = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (m?.[1]) return decodeURIComponent(m[1]);
  // filename="name.ext"
  m = cd.match(/filename\s*=\s*"([^"]+)"/i);
  if (m?.[1]) return m[1];
  // filename=name.ext
  m = cd.match(/filename\s*=\s*([^;]+)/i);
  if (m?.[1]) return m[1].trim();
  return null;
}

function filenameFromUrl(path: string): string | null {
  const clean = path.split('?')[0];
  const name = clean.split('/').pop() || '';
  return name && name.includes('.') ? name : null;
}
